import { useEsforcoTimeTab } from '@/hooks/useEsforcoTimeTab'
import { EsforcoTimeSummaryCards } from '@/components/Configuracao/EsforcoTimeSummaryCards'
import { EsforcoTimeToolbar } from '@/components/Configuracao/EsforcoTimeToolbar'
import { EsforcoTimeTaskTable } from '@/components/Configuracao/EsforcoTimeTaskTable'
import { EsforcoTimeTaskModal } from '@/components/Configuracao/EsforcoTimeTaskModal'

export function EsforcoTimeTab() {
  const tab = useEsforcoTimeTab()

  return (
    <div className="space-y-6">
      <EsforcoTimeSummaryCards
        totalHoursFormatted={tab.totalHoursFormatted}
        taskCount={tab.currentTasks.length}
        activeSubTab={tab.activeSubTab}
      />

      <EsforcoTimeToolbar
        activeSubTab={tab.activeSubTab}
        taskCounts={tab.taskCounts}
        searchQuery={tab.searchQuery}
        onSearchChange={tab.setSearchQuery}
        onSelectSubTab={tab.selectSubTab}
        onAdd={tab.handleOpenAdd}
      />

      <EsforcoTimeTaskTable
        tasks={tab.filteredTasks}
        searchQuery={tab.searchQuery}
        onClearSearch={() => tab.setSearchQuery('')}
        onEdit={tab.handleOpenEdit}
        onDelete={tab.handleDelete}
      />

      <EsforcoTimeTaskModal
        open={tab.showModal}
        isEdit={Boolean(tab.editId)}
        modalTask={tab.modalTask}
        modalHours={tab.modalHours}
        modalExecutor={tab.modalExecutor}
        onClose={() => tab.setShowModal(false)}
        onSave={tab.handleSaveModal}
        onTaskChange={tab.setModalTask}
        onHoursChange={tab.setModalHours}
        onExecutorChange={tab.setModalExecutor}
      />
    </div>
  )
}
